import { render, staticRenderFns } from "./i18nForm.vue?vue&type=template&id=c526eb9c&"
import script from "./i18nForm.vue?vue&type=script&lang=js&"
export * from "./i18nForm.vue?vue&type=script&lang=js&"
import style0 from "./i18nForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports